<template>
  <div style="position: sticky; top: 0px; z-index: 1040; background: white;">
    <b-navbar variant="faded" type="light" class="px-0">
      <b-navbar-nav class="d-flex d-md-none" style="font-size: 1.25rem;">
        <b-nav-item v-b-toggle.sidebar-menu>
          <font-awesome-icon icon="bars" />
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-brand :to="{ name: 'Home' }">
        <img
          src="/img/logo-web.png"
          style="height: 71px;"
          class="d-none d-md-block"
        />
        <img
          src="/img/logo-web.png"
          style="height: 61px;"
          class="d-block d-md-none"
        />
      </b-navbar-brand>
      <b-navbar-nav class="links d-none d-md-flex">
        <b-nav-item to="/libreria">Librería</b-nav-item>
        <b-nav-item to="/autores">Autores</b-nav-item>
        <b-nav-item to="/noticias">Sala de prensa</b-nav-item>
        <b-nav-item to="/nosotros">Nosotros</b-nav-item>
        <b-nav-item to="/contacto">Contacto</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav
        class="ml-auto d-none d-md-flex"
        style="font-size: 1.25rem;"
      >
        <b-nav-item
          @click="
            showSearch = !showSearch;
            $emit('change', showSearch);
          "
          :class="{ icon_active: showSearch }"
        >
          <font-awesome-icon icon="search" />
        </b-nav-item>
        <b-nav-item-dropdown
          style="font-size: 1rem; padding-top: .15rem;"
          right
          no-caret
        >
          <template v-slot:button-content>
            <b-avatar size="sm" style="background-color: rgba(0,0,0,.6);" />
          </template>
          <b-dropdown-text v-if="isLogged">
            <div class="d-flex" style="min-width: 12rem;">
              <b-avatar size="md" style="background-color: rgba(0,0,0,.6);" />
              <div class="ml-2" style="flex-shrink: 100;">
                Hola<br />
                {{ usrfullname }}
              </div>
            </div>
          </b-dropdown-text>
          <b-dropdown-divider v-if="isLogged"></b-dropdown-divider>
          <b-dropdown-item v-if="isLogged" class="text-left" to="/compras"
            ><span class="text-secondary"
              ><font-awesome-icon class="mr-2" icon="shopping-cart" /> Mis
              compras</span
            ></b-dropdown-item
          >
          <b-dropdown-item v-if="isLogged" class="text-left" to="/coupons"
            ><span class="text-secondary"
              ><font-awesome-icon class="mr-2" icon="ticket-alt" />
              Cupones</span
            ></b-dropdown-item
          >
          <b-dropdown-divider v-if="isLogged"></b-dropdown-divider>
          <b-dropdown-item
            v-if="isLogged"
            class="text-left"
            href="#"
            @click="Logout()"
            ><span class="text-secondary"
              ><font-awesome-icon class="mr-2 ml-1" icon="sign-out-alt" />
              Cerrar sesión</span
            ></b-dropdown-item
          >
          <b-dropdown-item v-if="!isLogged" class="text-left" href="#"
            v-b-modal.main-modal-login
            ><span class="text-secondary"
              ><font-awesome-icon class="mr-2 ml-1" icon="user-plus" />
              Registrarse</span
            ></b-dropdown-item
          >
          <b-dropdown-item
            v-if="!isLogged"
            class="text-left"
            href="#"
            v-b-modal.main-modal-login
            ><span class="text-secondary"
              ><font-awesome-icon class="mr-2 ml-1" icon="sign-in-alt" />
              Iniciar sesión</span
            ></b-dropdown-item
          >
        </b-nav-item-dropdown>
        <b-nav-item v-if="$route.path != '/favoritos'" to="/favoritos">
          <font-awesome-icon icon="heart" />
        </b-nav-item>
        <b-nav-item v-else class="icon_active" to="/favoritos">
          <font-awesome-icon icon="heart" />
        </b-nav-item>
        <b-nav-item
          v-b-toggle.sidebar-cart
          v-if="$route.path.substr(0, 5) != '/cart'"
        >
          <font-awesome-icon icon="shopping-cart" />
          <b-badge
            pill
            style="font-size:x-small; background: #e8661a;"
            v-if="cart > 0"
            >{{ cart }}</b-badge
          >
        </b-nav-item>
        <b-nav-item class="icon_active" v-else>
          <font-awesome-icon icon="shopping-cart" />
          <b-badge
            pill
            style="font-size:x-small; background: #e8661a;"
            v-if="cart > 0"
            >{{ cart }}</b-badge
          >
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav
        class="ml-auto d-md-none d-flex"
        style="font-size: 1.25rem;"
      >
        <b-nav-item
          v-b-toggle.sidebar-cart
          v-if="$route.path.substr(0, 5) != '/cart'"
        >
          <font-awesome-icon icon="shopping-cart" />
          <b-badge
            pill
            style="font-size:x-small; background: #e8661a;"
            v-if="cart > 0"
            >{{ cart }}</b-badge
          >
        </b-nav-item>
        <b-nav-item class="icon_active" v-else>
          <font-awesome-icon icon="shopping-cart" />
          <b-badge
            pill
            style="font-size:x-small; background: #e8661a;"
            v-if="cart > 0"
            >{{ cart }}</b-badge
          >
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <transition name="search" mode="in-out">
      <b-input-group class="pb-2" v-if="showSearch">
        <template v-slot:append>
          <b-input-group-text
            class="bg-white text-muted"
            style="border-left: none; cursor: pointer;"
            @click="search()"
          >
            <font-awesome-icon icon="search" />
          </b-input-group-text>
        </template>
        <b-form-input
          type="search"
          placeholder="Buscar por título, autor, tema o colección"
          style="border-right: none;"
          v-model="searchValue"
          @keyup="checksearch"
        ></b-form-input>
      </b-input-group>
    </transition>
    <side-cart />
    <b-sidebar
      id="sidebar-menu"
      title=""
      width="250px"
      sidebar-class="menu-sidebar"
      backdrop
      shadow
    >
      <b-list-group flush style="font-family: 'Poppins', sans-serif;">
        <b-list-group-item
          v-if="isLogged"
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
        >
          <div class="d-flex" style="min-width: 12rem;">
            <b-avatar size="md" style="background-color: rgba(0,0,0,.6);" />
            <div class="ml-2" style="flex-shrink: 100;">
              Hola<br />
              {{ usrfullname }}
            </div>
          </div>
        </b-list-group-item>

        <b-list-group-item
          to="/"
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          >Inicio</b-list-group-item
        >
        <b-list-group-item
          to="/libreria"
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          >Librería</b-list-group-item
        >
        <b-list-group-item
          to="/autores"
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          >Autores</b-list-group-item
        >
        <b-list-group-item
          to="/noticias"
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          >Sala de prensa</b-list-group-item
        >
        <b-list-group-item
          to="/nosotros"
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          >Nosotros</b-list-group-item
        >
        <b-list-group-item
          to="/contacto"
          style="background: #F1F1F1; border-bottom: 1px solid rgba(0,0,0,.125); padding: .5rem 1.25rem 1rem;"
          >Contacto</b-list-group-item
        >

        <b-list-group-item
          to="/favoritos"
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          v-if="isLogged"
          class="text-left"
          ><font-awesome-icon class="mr-2 ml-1" icon="heart" />
          Favoritos</b-list-group-item
        >
        <b-list-group-item
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          v-if="isLogged"
          class="text-left"
          to="/compras"
          ><font-awesome-icon class="mr-2" icon="shopping-cart" /> Mis
          compras</b-list-group-item
        >
        <b-list-group-item
          style="background: #F1F1F1; border-bottom: 1px solid rgba(0,0,0,.125); padding: .5rem 1.25rem 1rem;"
          v-if="isLogged"
          class="text-left"
          to="/coupons"
          ><font-awesome-icon class="mr-2" icon="ticket-alt" />
          Cupones</b-list-group-item
        >

        <b-list-group-item
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          v-if="isLogged"
          class="text-left"
          href="#"
          @click="Logout()"
          ><font-awesome-icon class="mr-2 ml-1" icon="sign-out-alt" /> Cerrar
          sesión</b-list-group-item
        >
        <b-list-group-item
          style="background: #F1F1F1; border: none; padding: 1rem 1.25rem .5rem;"
          v-if="!isLogged"
          class="text-left"
          href="#"
          v-b-modal.main-modal-login
          ><font-awesome-icon class="mr-2" icon="user-plus" />
          Registrarse</b-list-group-item
        >
        <b-list-group-item
          style="background: #F1F1F1; border: none; padding: .5rem 1.25rem;"
          v-if="!isLogged"
          class="text-left"
          href="#"
          v-b-modal.main-modal-login
          ><font-awesome-icon class="mr-2 ml-1" icon="sign-in-alt" /> Iniciar
          sesión</b-list-group-item
        >
      </b-list-group>
    </b-sidebar>
    <b-modal id="main-modal-login" hide-footer>
      <form-login @login="$bvModal.hide('main-modal-login')" @cancel="$bvModal.hide('main-modal-login')"  />
    </b-modal>
  </div>
</template>
<script>
import SideCart from "@/components/SideCart.vue";
import FormLogin from "@/components/FormLogin.vue"
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  components: {
    SideCart,
    FormLogin
  },
  data() {
    return {
      showSearch: false,
      searchValue: ''
    };
  },
  computed: {
    ...mapState({ isLogged: state => state.user.isLogged }),
    ...mapGetters({ cart: "countCartItems", usrfullname: "getUsrFullname" })
  },
  methods: {
    checksearch(event){
      console.log(event);
      if (event.keyCode === 13){
        this.search();
      }
    },
    search(){
      if(this.$route.name === 'Libreria'){
          this.$route.params.search = this.searchValue;
          this.$root.$emit('search');
        }else{
          this.$router.push({ name: "Libreria", params: { search: this.searchValue } });
        }
        this.searchValue = '';
        this.showSearch = false;
    },
    ...mapActions(["Logout"])
  }
};
</script>
